interface SparklineProps {
  data: number[]
  width?: number
  height?: number
  className?: string
}

/**
 * Klein trendlijntje voor in stat-tiles. Toont de vorm van een reeks,
 * met een accent-punt op de laatste waarde. Puur informatief.
 */
export function Sparkline({ data, width = 96, height = 32, className }: SparklineProps) {
  const points = data.filter((n) => Number.isFinite(n))
  if (points.length < 2) return null

  const max = Math.max(...points)
  const min = Math.min(...points)
  const span = max - min || 1
  const stepX = width / (points.length - 1)
  const pad = 3

  const coords = points.map((value, i) => {
    const x = i * stepX
    const y = pad + (height - pad * 2) * (1 - (value - min) / span)
    return [x, y] as const
  })

  const line = coords.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)} ${y.toFixed(1)}`).join(' ')
  const [lastX, lastY] = coords[coords.length - 1]

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      height={height}
      fill="none"
      aria-hidden
      className={className}
      preserveAspectRatio="none"
    >
      <path d={line} stroke="rgb(var(--ink-faint-rgb))" strokeOpacity={0.5} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      <circle cx={lastX} cy={lastY} r={2.5} fill="rgb(var(--accent-600-rgb))" />
    </svg>
  )
}
